<template>
  <div class="d-flex flex-row bd-highlight posess mx-auto mb-3 mt-5">
    <div class="w-100 bd-highlight">
      <p class="allow">A Blanket that allows to</p>
      <h1 class="sleep">
        Sleep in Luxary
        <br />Style
      </h1>
      <p class="serene mt-5">
        A wonderful serenity has taken possession of my entire soul, like these
        <br />sweet mornings of spring which I enjoy with my whole heart. I am
        <br />alone, and feel the charm of existence in this spot, which was created
        <br />for the bliss of souls like mine. I am so happy.
        <br />
        <br />A wonderful serenity has taken possession of my entire soul, like these
        <br />sweet mornings of spring.
      </p>
    </div>
    <div data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
      <div class="p-2 bd-highlight image">
        <img src="../../assets/img/lifestyle.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/page1/luxary.vue